import { ICellRendererParams } from 'ag-grid-community'
import { OrgStateUnitData } from 'types'
import { PLACEHOLDER } from './common'

export const formatOrgStateUnit = (data: OrgStateUnitData) => {
  const { organizationName, accessCodeSpecificState, accessCodeSpecificUnitName } = data
  const parts = [organizationName, accessCodeSpecificState, accessCodeSpecificUnitName].filter(
    Boolean,
  )
  return parts.join('/') || PLACEHOLDER
}

export const orgStateUnitRenderer = (props: ICellRendererParams<OrgStateUnitData>) => {
  return formatOrgStateUnit(props.data || {})
}
